export const stringifyId = (id) => `${id}`;

export const normalizeIdForApi = (id) => {
  const asNumber = Number(id);
  return Number.isFinite(asNumber) ? asNumber : id;
};

export const normalizePersonnelIds = (personnelIds) =>
  (Array.isArray(personnelIds) ? personnelIds : []).map((id) => normalizeIdForApi(id));

export const toUniqueNormalizedPersonnelIds = (personnelIds) => {
  const idsByKey = new Map();
  normalizePersonnelIds(personnelIds).forEach((id) => {
    idsByKey.set(stringifyId(id), id);
  });
  return Array.from(idsByKey.values());
};

export const getPersonnelSelectionDiff = (savedIds, draftIds) => {
  const savedSelection = toUniqueNormalizedPersonnelIds(savedIds);
  const draftSelection = toUniqueNormalizedPersonnelIds(draftIds);
  const savedLookup = new Set(savedSelection.map(stringifyId));
  const draftLookup = new Set(draftSelection.map(stringifyId));

  return {
    draftSelection,
    idsToAdd: draftSelection.filter((id) => !savedLookup.has(stringifyId(id))),
    idsToDelete: savedSelection.filter((id) => !draftLookup.has(stringifyId(id))),
  };
};

export const extractPersonnelIds = (personnelMap) =>
  Object.values(personnelMap || {})
    .map((person) => person?.userId ?? person?.id)
    .filter((id) => id != null)
    .map(stringifyId);

export const extractPersonnelDutyIds = (person) => {
  const rawDuty =
    person?.dutyPriority ??
    person?.duty_priority ??
    person?.dutyId ??
    person?.duty_id ??
    person?.duty?.id ??
    null;

  const values = Array.isArray(rawDuty) ? rawDuty : [rawDuty];
  return values
    .map((value) => {
      if (value == null) return null;
      if (typeof value === 'object') {
        return value?.id ?? value?.dutyId ?? value?.duty_id ?? null;
      }
      return value;
    })
    .filter((value) => value != null);
};

export const extractPersonnelIsSupervisor = (person) => {
  const rawSupervisor =
    person?.isSupervisor ?? person?.is_supervisor ?? person?.isSupervisorDuty ?? false;

  if (typeof rawSupervisor === 'string') {
    const normalized = rawSupervisor.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
  }

  return Boolean(rawSupervisor);
};

export const toStringDutyIds = (value) => {
  if (value == null) return [];
  const values = Array.isArray(value) ? value : [value];
  return values
    .map((item) => (item == null ? null : stringifyId(item)))
    .filter((item) => item != null && item !== '');
};

export const timeAgo = (timestamp, currentTime) => {
  if (!timestamp) return '-';
  const now = currentTime;
  const time = new Date(timestamp);
  const diffInSeconds = Math.floor((now - time) / 1000);

  if (diffInSeconds < 10) return 'Live';
  if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
  return `${Math.floor(diffInSeconds / 86400)}d ago`;
};
